/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react'
import { FaSearch, FaFileExport } from 'react-icons/fa'
import Divider from '@material-ui/core/Divider'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'bootstrap-daterangepicker/daterangepicker.css'
import moment from 'moment'

const ReportActivity = (props): JSX.Element => {
  const {
    // handleDayChange,
    handleDateChange,
    exportFullData,
    isLoading,
  } = props

  // const onCustomDayChange = (day): void => {
  //   handleDayChange(day)
  // }

  const handleEvent = (event, picker): void => {
    console.log('handleEvent', picker.startDate.toISOString())
    handleDateChange(picker.startDate.toISOString(), picker.endDate.toISOString())
  }

  const handleCallback = (start, end): void => {
    console.log('handleCallback', start, end)
  }

  useEffect(() => {
    // onCustomDayChange('1 DAY')
  }, [])

  return (
    <div className="report-activity">
      <div className="highlights">
        <div className="highlights-container first">
          <p className="title">ACTIVITY WINDOW</p>
          <Divider orientation="vertical" flexItem />
          {/* {days.map((item, index) => (
            <div
              role="button"
              tabIndex={0}
              className={`highlight ${
                currentDay === item.replace(' DAYS', '').replace(' DAY', '') ? 'active' : ''
              } ${index === days.length - 1 ? 'no-border' : ''}`}
              key={`engagement highlight - ${item}`}
              onClick={(): Promise<void> => handleDayChange(item)}
              onKeyDown={(): void => {}}
            >
              {item}
            </div>
          ))} */}
          {/* <div className="search-container">
            <FaSearch className="search-icon" />
            <FormControl
              autoFocus
              type="number"
              min={1}
              placeholder="DAYS"
              value={currentDay.toString()}
              className="custom-day"
              onChange={(e: ChangeEvent<HTMLInputElement>): void => {
                onCustomDayChange(e.currentTarget.value)
              }}
            />
          </div> */}
          <div className="search-container">
            <FaSearch className="search-icon" />
            <DateRangePicker
              initialSettings={{
                startDate: moment().toDate(),

                endDate: moment().toDate(),

                ranges: {
                  Today: [moment().toDate(), moment().toDate()],

                  Yesterday: [
                    moment()
                      .subtract(1, 'days')
                      .toDate(),

                    moment()
                      .subtract(1, 'days')
                      .toDate(),
                  ],

                  'Last 7 Days': [
                    moment()
                      .subtract(6, 'days')
                      .toDate(),

                    moment().toDate(),
                  ],

                  'Last 30 Days': [
                    moment()
                      .subtract(29, 'days')
                      .toDate(),

                    moment().toDate(),
                  ],

                  'This Month': [
                    moment()
                      .startOf('month')
                      .toDate(),

                    moment()
                      .endOf('month')
                      .toDate(),
                  ],

                  'Last Month': [
                    moment()
                      .subtract(1, 'month')
                      .startOf('month')
                      .toDate(),

                    moment()
                      .subtract(1, 'month')
                      .endOf('month')
                      .toDate(),
                  ],
                },
              }}
              // initialSettings={{ startDate: '01/01/2020', endDate: '11/24/2021' }}
              onApply={handleEvent}
              onCallback={handleCallback}
            >
              <input
                type="text"
                className="form-control date-range"
                placeholder="DATE RANGE"
                disabled={isLoading}
              />
            </DateRangePicker>
          </div>
        </div>
        <Divider orientation="vertical" flexItem />
        <div className="highlights-container export-section">
          <p className="title">EXPORT REPORT</p>
          <Divider orientation="vertical" flexItem />
          <FaFileExport className="filter-icon" onClick={exportFullData} />
        </div>
      </div>
    </div>
  )
}

export default ReportActivity
